import React, { useState } from 'react';
import './pedidos-card.css';
import { useNavigate } from 'react-router-dom';
import { useOrders } from '../../contexts/OrdersContext';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Buttons from '../button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DoneIcon from '@mui/icons-material/Done';

interface PedidosCardProps {
  info: {
    pedido: string;
    cliente: string;
    data: string;
    amostras: number;
    imported: boolean;
  };
}

const PedidosCard: React.FC<PedidosCardProps> = ({ info }) => {
  const navigate = useNavigate();
  const {confirmImport} = useOrders();
  const [error, setError] = useState<string | null>(null);

  const viewPedidosNavigation = (numPedido: string) => {
    navigate(`/pedidos/${numPedido}`); 
  };
  const resend = async () => {
      try {
          await confirmImport(info.pedido);
          setError(null);  
      } catch (err: any) {
          setError(err.message || "Erro ao confirmar importação.");
          alert(err.message);
      }
  };

  return (
    <Card className="pedidos-card">
      <Box className="pedidos-left">
        <CardContent className="pedidos-data">
          <Typography sx={{ color: '#707070', fontSize: 14 }}>PEDIDO</Typography>
          <Typography gutterBottom sx={{ fontSize: 16 }}>
            {info.pedido}
          </Typography>
        </CardContent>
        <CardContent className="pedidos-data">
          <Typography sx={{ color: '#707070', fontSize: 14 }}>CLIENTE</Typography>
          <Typography gutterBottom sx={{ fontSize: 16, whiteSpace: 'nowrap', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            maxWidth: '150px'}}>
            {info.cliente}
          </Typography>
        </CardContent>
        <CardContent className="pedidos-data">
          <Typography sx={{ color: '#707070', fontSize: 14 }}>DATA APROVAÇÃO</Typography>
          <Typography gutterBottom sx={{ fontSize: 16 }}>
            {info.data}
          </Typography>
        </CardContent>
        <CardContent className="pedidos-data">
          {/*<Typography sx={{ color: '#707070', fontSize: 14 }}>STATUS</Typography>*/}
          <Typography gutterBottom sx={{ fontSize: 16 }}>
            {info.imported ? <DoneIcon sx={{display: 'flex', 
            color: "var(--primary-color)", 
            fontSize: '35px', 
            alignItems: 'center', 
            alignContent: 'center', marginRight: 10}} /> : <Buttons
                                label="Confirmar Pedido"
                                onClick={resend}
                                backgroundColor="#fff"
                                borderColor="var(--primary-color)"
                                textColor="var(--primary-color)"
                                size="small"
                                sx={{
                                    boxShadow: 'none', 
                                    padding: '0.5rem 1rem', 
                                    marginTop: 1
                                  
                                }}
                            />}
          </Typography>
        </CardContent>
      </Box>
      <Box className="pedidos-right">
        {/*<Button
          label="VER PEDIDO"
          onClick={() => viewPedidosNavigation(info.pedido)}
          backgroundColor="#fff"
          borderColor="var(--primary-color)"
          textColor="var(--primary-color)"
          size="small"
          endicon={<ArrowForwardIcon />
          }
        />
        <Button
          label="RELATÓRIO DO PEDIDO"
          onClick={() => alert('Botão clicado!')}
          backgroundColor="#fff"
          borderColor="var(--primary-color)"
          textColor="var(--primary-color)"
          size="small"
          endicon={<FileDownloadIcon />}
        />*/}
      </Box>
    </Card>
  );
};

export default PedidosCard;
